import OcorrenciaAPI from '@/api/ocorrencia'

export default {
  clear({ commit }) {
    commit('SET_OCORRENCIAS', [])
  },
  clearEventos({ commit }) {
    commit('SET_EVENTOS', [])
  },
  fetchOcorrencias({ commit }, params) {
    return new Promise((resolve, reject) => {
      OcorrenciaAPI.list(params.pagina)
        .then(response => {
          commit('ADD_OCORRENCIAS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchOneOcorrencia({ commit }, params) {
    return new Promise((resolve, reject) => {
      OcorrenciaAPI.obter(params.id)
        .then(response => {
          commit('ADD_OCORRENCIAS', [response.data])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchEventos({ commit }, params) {
    return new Promise((resolve, reject) => {
      OcorrenciaAPI.listEventos(params.ocorrencia.id)
        .then(response => {
          commit('ADD_EVENTOS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveEvento({ commit }, params) {
    return new Promise((resolve, reject) => {
      OcorrenciaAPI.gravarEvento(params)
        .then(response => {
          commit('SET_EVENTOS', [])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveOcorrencia({ commit }, params) {
    return new Promise((resolve, reject) => {
      OcorrenciaAPI.gravarOcorrencia(params)
        .then(response => {
          commit('SET_OCORRENCIAS', [])
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
